/*=========================================================================================
  File Name: moduleAdminState.js
  Description: Report Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {

    fileDownloadCountReportSeries: [],

    countOfUploadedFile: 0,
    countOfNotUploadedFile: 0,
    sumOfSUsedStorage: 0,

    streamingDurationReportSeries: [],
    streamingDurationReportList: [],
    streamingDurationReportCount: 0,

    subscriptionReportSeries: [],

    countOfSubscriptionPurchase: 0,
    countOfSubscriptionRenewed: 0,
    countOfSubscriptionCanceled: 0,

    s3UsageReportSeries: [],
    wowzaUsageReportSeries: []


}